<h1 class="page-title w-50"> قطاع التعدين</h1>
<div class="pb-5">
  <div class="d-flex justify-content-between">
    <div class="share-section mb-4 w-50 pt-5">
      <div class="share-text mb-2">شارك المقال على</div>
      <div class="social-icons d-flex justify-content-end gap-2">
        <a href="#" class="social-icon">
          <i class="fa-brands fa-twitter"></i>
        </a>
        <a href="#" class="social-icon">
          <i class="fa-brands fa-facebook-f"></i>
        </a>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="banner-container">
      <img src="../../../assets/minning.jpg" alt=" " class="banner-image" />
      <div class="growth-badge">
        <span> مصر أرض غنية بالثروة المعدنية مثل الرمل الأبيض، الذهب و الرمل الزجاجي.</span>
      </div>
    </div>

    <div class="sector-content">
      <p> قطاع التعدين</p>
      <hr />
      <p> عن قطاع التعدين: </p>
      <p>
        الثروة المعدنية:تمتلك مصر ثروة معدنية متنوعة من حيث النوع والكمية ومواقع توزيعها، وتصنف هذه الثروة إلى خمس فئات
        أساسية:خامات صلبة: تتعدد أنواع هذه الخامات ومن أهمها المواد الكربونية مثل الفحم الموجودة في صخور ما فوق تكوين
        الفوسفات في محافظات البحر الأحمر والوادي الجديد.المواد المشعة: مثل اليورانيوم الموجود في صخور الصحراء الشرقية
        وسيناء والذي يُستخدَم في إنتاج الطاقة النووية.الفلزات: تتضمن ثلاثة أنواع هي خام الحديد والمواد اللافلزية
        والمعادن النفيسة.خام الحديد: مثل الحديد الذي يعتبر من أهم الثروات المعدنية المشهورة في مصر، وهو أساس الصناعات
        الثقيلة التي تصدر عنها صناعة السيارات والقطارات والإنشاءات.وهناك أيضًا العديد من المواد غير الحديدية مثل النحاس،
        وكذا المعادن النفيسة مثل الفضة والبلاتين والذهب، والمواد اللافلزية، وأخيرًا المواد الخام للصناعات الكيماوية
        والأسمدة، وكل هذه المعادن متوفِّرة بكميات ضخمة ويتم استغلالها في الإنتاج والتصدير.مواد البناء: مثل الجرانيت
        والرخام والرمل الأبيض والحجر الجيري.الصحراء الشرقية:تمتد الصحراء الشرقية من وادي النيل في الغرب إلى البحر الأحمر
        وخليج السويس وقناة السويس في الشرق، ومن بحيرة المنزلة على البحر المتوسط في شمال مصر إلى الحدود الجنوبية مع
        السودان في الجنوب. وتتميز الصحراء الشرقية بالجبال الشرقية الممتدة على طول البحر الأحمر بقمم ترتفع إلى حوالي 3000
        قدم فوق مستوى سطح البحر. وهذه الصحراء غنية بالموارد الطبيعية بما في ذلك مختلف الخامات مثل الذهب والفحم والبترول.
        شبه جزيرة سيناء:تشبه شبه جزيرة سيناء المثلث؛ فقاعدتها في البحر المتوسط في الشمال ورأسها في الجنوب في منطقة رأس
        محمد وشرقه خليج العقبة وغربه خليج السويس وقناة السويس. وتنقسم شبه الجزيرة طبوغرافيًا إلى ثلاثة أقسام
        رئيسية:القسم الجنوبي وهو عبارة عن تضاريس وعرة من جبال الجرانيت عالية الارتفاع.جبل كاترين الواقع على ارتفاع 2640
        مترًا فوق مستوى سطح البحر، مما يجعله أعلى قمة جبلية في مصر.القسم الأوسط ويحده شمالًا البحر المتوسط وجنوبًا هضبة
        التيه، وهو عبارة عن منطقة سهول تحتوي على موارد مائية وفيرة مستمدة من مياه الأمطار تتدفق من المرتفعات الجنوبية
        إلى الهضبة الوسطى.​​

      </p>
      <a href="https://www.investinegypt.gov.eg/Arabic/Pages/exploreMap.aspx?secId=129">لمزيد من المعلومات اضغط هنا</a>
    </div>
  </div>
</div>